<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Choose Size</h5>
    <div class="widget-category-list mt-20">
      <div class="single-widget-category pointer" v-for="size in sizes_data" :key="size.capacity_id">
        <input type="checkbox" :id="`Size-item-${size.capacity_id}`"
          :class="{ checked: activeSize == size.capacity_id }">
        <label @click="handleSizeRoute(size.capacity_id)" :for="`size-item-${size.capacity_id}`" class="pointer">
          {{ size.capacity_name }} <span></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSizes",
  data() {
    return {
      sizes_data: [], // Initialize as an empty array
      activeSize: "",
    }
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        this.activeSize = newQuery.Size || ''
      },
      immediate: true,
    },
  },
  methods: {
    async fetchSizes() {
      try {
        const response = await this.$axios.get('/sizes') // Replace with your actual API endpoint
        this.sizes_data = response.data
      } catch (error) {
        console.error("Error fetching Sizes:", error)
      }
    },
    handleSizeRoute(value) {
      const currentQuery = { ...this.$route.query } // Preserve existing query params
      currentQuery.size = value // Update size query param

      this.$router.push({
        path: '/shop',
        query: currentQuery, // Keep existing query parameters (including web_category & brand)
      })
    },
    formatUrl(value) {
      return value.toLowerCase().replace(/\s+/g, '-')
    },
  },
  mounted() {
    this.activeSize = this.$route.query.Size // Set active Size from the route query
    this.fetchSizes() // Fetch Sizes when the component is mounted
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.single-widget-category label::after {
  font-family: 'Font Awesome 5 Free';
  content: '\f00c';
  font-weight: 900;
  /* Ensures solid icon */
}
</style>
